import React from 'react';
import Header from '../component/Header';
import Footer from '../component/footer';

const Imprint = () => {
  return (
    <>
      <Header />

      <div className="min-h-screen flex flex-col bg-[#F4F5F7] font-sans text-gray-800">

        <main className="flex-grow w-full max-w-[1280px] mx-auto px-4 md:px-8 py-12 md:py-20">

          {/* Content Card */}
          <div className="bg-white rounded-[2.5rem] shadow-[0_8px_30px_rgb(0,0,0,0.04)] border border-gray-100 p-8 md:p-12 lg:p-16">

            {/* Page Header */}
            <div className="mb-12">
              <h1 className="text-3xl md:text-5xl font-extrabold text-[#113A28] tracking-tight mb-6">
                Imprint
              </h1>
              <div className="w-16 h-1.5 bg-[#4CE470] rounded-full mb-8"></div>
              <p className="text-sm text-gray-500 leading-relaxed">
                This page provides the legal disclosure information for this website.
              </p>
            </div>

            <hr className="mb-12 border-gray-100" />

            {/* Imprint Content */}
            <div className="grid grid-cols-1 gap-12 leading-relaxed text-gray-600">

              <section>
                <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">Company Information</h2>
                <div className="space-y-2">
                  <p><strong className="text-[#113A28]">Company Name:</strong> OLBMI LIMITED</p>
                  <p><strong className="text-[#113A28]">Registered Address:</strong> Mnasiadou, 10, 2nd Floor, 1065, Nicosia, Cyprus</p>
                  <p><strong className="text-[#113A28]">Represented by / Director:</strong> Theodora Kyriakou</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">Registration and Tax Information</h2>
                <div className="space-y-2">
                  <p><strong className="text-[#113A28]">Company Registration Number:</strong> HE489301</p>
                  <p><strong className="text-[#113A28]">Tax Identification Number:</strong> 60346740F</p>
                  <p><strong className="text-[#113A28]">VAT Identification Number:</strong> CY60346740F</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">Contact</h2>
                <p>
                  <strong className="text-[#113A28]">Email:</strong>{' '}
                  <a
                    href="mailto:support@learnwebacademy.net"
                    className="text-[#4CE470] hover:underline"
                  >
                    support@learnwebacademy.net
                  </a>
                </p>
              </section>

              <section>
                <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">Responsible for Website Content</h2>
                <div className="space-y-1">
                  <p>OLBMI LIMITED</p>
                  <p>Mnasiadou, 10, 2nd Floor</p>
                  <p>1065, Nicosia</p>
                  <p>Cyprus</p>
                </div>
              </section>

              <section>
                <h2 className="text-xl md:text-2xl font-bold text-[#113A28] mb-4">Disclaimer</h2>
                <p className="mb-4">
                  The information provided on this website is for general informational purposes only. While we make every effort to keep the content accurate and up to date, we do not accept liability for any errors, omissions, or outdated information.
                </p>
                <p>
                  This imprint is provided for transparency and legal disclosure purposes. For any questions regarding the website or company information, please contact us using the email address listed above.
                </p>
              </section>

            </div>
          </div>
        </main>
      </div>

      <Footer />
    </>
  );
};

export default Imprint;
